export const FETCH_APILOGS = 'FETCH_APILOGS';

export const FETCH_APILOGS_IS_PENDING = 'FETCH_APILOGS_IS_PENDING';

export const FETCH_APILOGS_IS_ERROR = 'FETCH_APILOGS_IS_ERROR';

export const FILTER_APILOGS = 'FILTER_APILOGS';
